import React, { useEffect, useRef } from "react";
import gsap from "gsap";

import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.jpg";
import stickImg from "../assets/stick.jpg";
import img3 from "../assets/img3.jpg";
import img4 from "../assets/img4.jpg";

import "../styles/Banner.css";

const images = [img1, img2, stickImg, img3, img4];

const Banner = () => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;

    const handleLoad = () => {
      const totalWidth = track.scrollWidth / 2; // because we duplicate

      const proxy = { x: 0 };

      gsap.to(proxy, {
        x: -totalWidth,
        duration: 30,
        ease: "none",
        repeat: -1,
        modifiers: {
          x: gsap.utils.wrap(-totalWidth, 0),
        },
        onUpdate: () => {
          gsap.set(track, { x: proxy.x });
        },
      });
    };

    const imgs = track.querySelectorAll("img");
    let loaded = 0;

    imgs.forEach((img) => {
      if (img.complete) {
        loaded++;
      } else {
        img.addEventListener("load", () => {
          loaded++;
          if (loaded === imgs.length) handleLoad();
        });
      }
    });

    if (loaded === imgs.length) handleLoad();
  }, []);

  return (
    <section className="banner-container">
      <div className="banner-track" ref={trackRef}>
        {[...images, ...images].map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`banner-${idx}`}
            className="banner-img"
          />
        ))}
      </div>
    </section>
  );
};

export default Banner;
